import type {
  AccessToken,
  AudioIoConfig,
  BrowserSourceInfo,
  LogEvent,
  OutputConfig,
  OutputStatus,
  ParticipantInfo,
  PositionConfig,
  SourceConfig,
  SourceHealth,
  TallyProviderConfig,
  UserRecord,
} from '../../../../shared/src/types';

export interface Overview {
  sources: SourceConfig[];
  positions: PositionConfig[];
  tallyProviders: TallyProviderConfig[];
  audio: AudioIoConfig;
  outputs: OutputConfig[];
  outputStatus: OutputStatus[];
  browserSources: BrowserSourceInfo[];
  users: UserRecord[];
  tokens: Array<AccessToken & { positionName: string; url: string }>;
  caps: {
    encoders: Record<string, { available: boolean; reason?: string }>;
    fallbackSwitch: boolean;
    ndi: boolean;
    decklink: boolean;
    burnIn: boolean;
    textOverlay: boolean;
    detectedAt: number;
  };
  health: Record<string, SourceHealth>;
  tallyStatus: Array<{ id: string; name: string; kind: string; connected: boolean; detail: string; lastUpdate: number; program: string[]; preview: string[] }>;
  truck: {
    input: { kind: string; state: string; levelDb: number | null; lastError: string | null; talking: boolean };
    output: { enabled: boolean; state: string; levelDb: number | null; lastError: string | null; slotsUsed: number; slots: number };
  };
  participants: ParticipantInfo[];
  occupancy: Record<string, number>;
  events: LogEvent[];
  baseUrl: string;
  dev: boolean;
}

export interface Devices {
  decklink: Array<{ name: string; device: number }>;
  ndi: Array<{ name: string; url: string }>;
  audioSources: Array<{ name: string; factory: string; device: string }>;
  audioSinks: Array<{ name: string; factory: string; device: string }>;
  error?: string;
}

export const clone = <T,>(x: T): T => JSON.parse(JSON.stringify(x));
